const Function = require("core/src/function");
const View = require("core/src/functions/view");
const _ = require("core/src/utils/legacy");

const ContainerListView = Function.extend(View, "ContainerListView");

/**
 * @override
 * @returns {undefined}
 */
ContainerListView.prototype.onInit = function () {
	this.setParameters({
		'$options': {
			includeSelf: false,
			refreshIntervalMs: 1000,
			ttRefresh: "",
			ttFocus: "",
			ttMaximize: "",
			ttMinimize: "",
			ttNormalize: "",
			ttClose: "",
			exclude: []
		},
		'$search': ""
	});
};

/**
 * @override
 * @param {object} renderData
 * @returns {object}
 */
ContainerListView.prototype.alterRenderData = function (renderData) {
	if (!_.isObject(renderData.options)) {
		renderData.options = {};
	}

	if (_.isString(renderData.search) && _.isEmpty(renderData.options.search)) {
		renderData.options.search = renderData.search;
	}

	return renderData;
};

module.exports = ContainerListView;
